<template>
    <div class="main">
        <a-form-model :model="form" ref="settings-dingtalk" :rules="rules" :label-col="label_col" :wrapper-col="wrapper_col" class="form">
            <h2 class="h2">钉钉基本配置</h2>
            <a-divider />
            <a-form-model-item label="CorpId" prop="dd_corpid">
                <a-input v-model="form.dd_corpid" class="input" />
            </a-form-model-item>

            <a-form-model-item label="AgentId" prop="dd_agentid">
                <a-input v-model="form.dd_agentid" class="input" />
            </a-form-model-item>

            <a-form-model-item label="AppKey" prop="dd_appkey">
                <a-input v-model="form.dd_appkey" class="input" />
            </a-form-model-item>

            <a-form-model-item label="AppSecret" prop="dd_appsecret">
                <a-input v-model="form.dd_appsecret" class="input" />
            </a-form-model-item>

            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" :disabled="submitting || loading" @click="on_submit">保存</a-button>
            </a-form-model-item>
        </a-form-model>

        <h2 class="h2">测试连接状态</h2>
        <a-divider />

        <a-form-model layout="inline" style="margin-left:16px;">
            <a-form-model-item label="消息接收者的手机号码">
                <a-input v-model="test_mobile"></a-input>
            </a-form-model-item>
            <a-form-model-item>
                <a-button :disabled="testing || !test_mobile" @click="on_test">测试</a-button>
            </a-form-model-item>
        </a-form-model>
        <a-divider />

        <h2 class="h2">使用说明</h2>

        <div class="explain-block">
            <a-alert
                message="系统通知功能依赖钉钉，在使用以及配置前请确保您所在的组织已经开通并使用钉钉。"
                style="margin-bottom:24px"
                show-icon
                type="info"
            />
            <p>
                <strong>操作流程：</strong>
            </p>
            <ul>
                <li>
                    1、前往登录/注册
                    <a target="_blank" href="https://open-dev.dingtalk.com/">https://open-dev.dingtalk.com/</a>
                    钉钉开发者后台，初次使用可能需要认证。
                </li>
                <li>
                    2、在认证通过的情况下，前往
                    <a target="_blank" href="https://open-dev.dingtalk.com/#/index">https://open-dev.dingtalk.com/#/index</a>
                    复制<code>CorpId</code>。
                </li>
                <li>
                    3、前往
                    <a target="_blank" href="https://open-dev.dingtalk.com/#/corph5">https://open-dev.dingtalk.com/#/corph5</a>
                    创建H5微应用，应用名称、应用描述、应用图标、开发方式可以随意自定义。
                </li>
                <li>
                    4、点击创建好的H5应用，在凭证与基础信息>应用凭证处，依次复制
                    <code>AgentId</code> <code>AppKey</code> <code>AppSecret</code>。至此，系统所需要的配置已经完成。
                </li>

                <li>
                    5、点击Tab栏的“开发管理”，编辑开发管理管理系统。开发模式：<code>开发应用</code>，服务器出口IP：<code>47.111.146.96</code>，应用首页地址：<code
                    ></code>
                </li>

                <li>
                    6、点击Tab栏的“权限管理”，选择权限范围：<code>全部员工</code>，已添加接口权限：登录>身份验证，消息>消息通知，消息>企业会话，通讯录>手机号获取userid
                </li>

                <li>
                    7、最后：点击Tab栏的“版本管理与发布”，进行应用发布，发布范围选择
                    <code>全部员工</code>
                </li>
            </ul>
            <br />
            <p>
                <strong>注意事项：</strong>
            </p>
            <ul>
                <li>
                    系统会通过后台用户手机号码获取钉钉ID，请确保用户登录号码与钉钉的内的手机号码一致。
                </li>
                <li>
                    当某个员工离职，并从钉钉组织内移除后，将不会收到后续的任何消息提醒。
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                label_col: { span: 4 },
                wrapper_col: { span: 14 },
                submitting: false,
                loading: false,
                testing: false,
                test_mobile: null,
                rules: {
                    dd_corpid: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请填写CorpId",
                        },
                    ],
                    dd_agentid: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请填写AgentId",
                        },
                    ],
                    dd_appkey: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请填写AppSecret",
                        },
                    ],
                    dd_appsecret: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请填写AppSecret",
                        },
                    ],
                },
                form: {
                    dd_corpid: "",
                    dd_agentid: "",
                    dd_appkey: "",
                    dd_appsecret: "",
                },
            };
        },
        created() {
            this.load();
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/setting/dingtalk", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.form = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_submit() {
                this.$refs["settings-dingtalk"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/setting/dingtalk", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.$message.success(res.message);
                                    //this.load_config();
                                } else {
                                    this.$error({
                                        centered: true,
                                        title: "失败",
                                        content: res.message,
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_test() {
                this.testing = true;
                this.$http
                    .post("/setting/dingtalk/test", { mobile: this.test_mobile })
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                        } else {
                            this.$error({
                                centered: true,
                                title: "失败",
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.testing = false;
                    });
            },
        },
    };
</script>
<style lang="less" scoped>
    .main {
        top: 0 !important;
        .h2 {
            margin-top: 32px;
            margin-left: 16px;
        }
        .input {
            max-width: 300px;
        }
    }
</style>
